/**
 * Created by mateimisarca on 2019-06-07
 */

import TraineriPage from './traineri-page';

export default TraineriPage;
